import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { graphicsAPI } from "../api";

// Get all graphics items for admin
export const useGetGraphicsItems = (search?: string) => {
  return useQuery({
    queryKey: ["adminGraphicsItems", search],
    queryFn: () => graphicsAPI.getAllItems(search),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Get single graphics item by ID
export const useGetGraphicsItemById = (id: string) => {
  return useQuery({
    queryKey: ["adminGraphicsItem", id],
    queryFn: () => graphicsAPI.getItemById(id),
    enabled: !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Create graphics item mutation
export const useCreateGraphicsItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data, file }: { data: any; file?: File }) => {
      if (file) {
        return graphicsAPI.createItemWithFile(data, file);
      } else {
        return graphicsAPI.createItem(data);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["adminGraphicsItems"] });
    },
  });
};

// Update graphics item mutation
export const useUpdateGraphicsItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      data,
      file,
    }: {
      id: string;
      data: any;
      file?: File;
    }) => {
      if (file) {
        return graphicsAPI.updateItemWithFile(id, data, file);
      } else {
        return graphicsAPI.updateItem(id, data);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["adminGraphicsItems"] });
    },
  });
};

// Delete graphics item mutation
export const useDeleteGraphicsItem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => graphicsAPI.deleteItem(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["adminGraphicsItems"] });
    },
  });
};
